// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"selected-user__wrapper-3B6Nc","header":"selected-user__header-37M6E","line":"selected-user__line-FrlTy","block":"selected-user__block-3ExgK","noneSelected":"selected-user__noneSelected-2Sfhd","message":"selected-user__message-3VD0U"};


//////////////////
// WEBPACK FOOTER
// ./components/account/users/selected-user/selected-user.css
// module id = 783
// module chunks = 0